import { ArrowLeftRight, ShieldCheck, Users } from 'lucide-react';
import { Button } from '../../../ui/common-ui/button';
import { useGraphStore } from '../store/graphStore';
import type { PolicyCoverageView } from '../types/graph';

interface PolicyCoverageViewToggleProps {
  onChange: (view: PolicyCoverageView) => void;
}

export function PolicyCoverageViewToggle({ onChange }: PolicyCoverageViewToggleProps) {
  const { policyCoverageView, isModeLoading } = useGraphStore();
  const nextView = policyCoverageView === 'entity' ? 'policy' : 'entity';
  const CurrentIcon = policyCoverageView === 'entity' ? Users : ShieldCheck;

  return (
    <Button
      type="button"
      variant="outline"
      disabled={isModeLoading}
      onClick={() => onChange(nextView)}
      className="h-10 gap-2 whitespace-nowrap rounded-full border-border/50 bg-background/80 px-3 lg:px-4 shadow-lg backdrop-blur-md"
      title={policyCoverageView === 'entity' ? 'Center policies' : 'Center entities'}
    >
      <CurrentIcon className="h-4 w-4 text-purple-500" />
      <span>Switch View</span>
      <ArrowLeftRight className="h-4 w-4" />
    </Button>
  );
}
